import { Link } from "react-router-dom";
import { getTrending, titles } from "@/utils/catalog";
import Stars, { SectionTitle } from "@/components/base/Rating";

export default function HotRanking() {
  const ranking = getTrending(6);
  const tvList = titles.filter((t) => t.kind === "tv").slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 pt-14 md:pt-20">
      <SectionTitle
        accentLabel="Top Charts"
        title="热门剧集"
        subtitle="按播放量与评分综合排序，看看大家这周都在追什么。"
        moreTo="/category/tv"
        moreLabel="全部剧集"
      />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 md:gap-6">
        <div className="lg:col-span-7 rounded-lg bg-background-50 border border-background-200 overflow-hidden">
          <div className="flex items-center justify-between px-4 md:px-5 h-12 border-b border-background-200 bg-background-100">
            <span className="font-heading text-sm font-bold text-foreground-900">
              本周播放榜
            </span>
            <span className="text-[11px] text-foreground-500 font-label">更新于今日 06:00</span>
          </div>
          <ul>
            {ranking.map((item, i) => (
              <li key={item.id}>
                <Link
                  to={`/detail/${item.id}`}
                  className="group flex items-center gap-3 px-3 md:px-5 py-3 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <span
                    className={`w-6 text-center font-label text-lg font-extrabold tabular-nums shrink-0 ${
                      i < 3 ? "text-accent-500" : "text-background-400"
                    }`}
                  >
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <div className="w-11 h-16 rounded-md overflow-hidden bg-background-200 shrink-0">
                    <img
                      src={item.cover}
                      alt={`${item.title} 海报`}
                      title={`${item.title} - ${item.genres.join("、")} - CC视频`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="min-w-0 flex-1">
                    <h3 className="text-sm font-medium text-foreground-950 truncate group-hover:text-accent-600 transition-colors">
                      {item.title}
                    </h3>
                    <p className="mt-0.5 text-xs text-foreground-500 truncate">
                      {item.genres.join(" / ")} · {item.region} · {item.year}
                    </p>
                    <div className="mt-1.5 flex items-center gap-3">
                      <Stars rating={item.rating} />
                      <span className="text-[11px] text-foreground-400 font-label tabular-nums">
                        {(item.views / 10000).toFixed(0)}万
                      </span>
                    </div>
                  </div>
                  <i className="ri-play-circle-line text-xl text-background-400 group-hover:text-accent-500 transition-colors w-5 h-5 hidden sm:flex items-center justify-center" />
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-5 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 gap-3 md:gap-4">
          {tvList.map((item) => (
            <Link
              key={item.id}
              to={`/detail/${item.id}`}
              className="group relative rounded-lg overflow-hidden bg-primary-950 cursor-pointer"
            >
              <div className="w-full aspect-[4/5]">
                <img
                  src={item.cover}
                  alt={`${item.title} 剧集封面`}
                  title={`${item.title} - ${item.genres.join("、")} - CC视频`}
                  className="w-full h-full object-cover object-top opacity-90 transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950 via-primary-950/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-2.5 md:p-3">
                <h3 className="text-xs md:text-sm font-medium text-background-50 truncate">
                  {item.title}
                </h3>
                <p className="mt-1 text-[10px] md:text-[11px] text-background-300 truncate">
                  {item.duration}
                </p>
              </div>
              <span className="absolute top-2 right-2 px-1.5 py-0.5 rounded text-[10px] font-label font-semibold bg-accent-500 text-primary-950">
                {item.rating.toFixed(1)}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}